import React, { useState, useCallback } from 'react'
import Cropper from 'react-easy-crop'
import { convertBlobToBase64, getCroppedImg } from '../../../../../utils/helpers'
import { BASE_URL_IMAGE } from '../../../../../services/ApiEndpoints'
import ToggleSwitch from '../../../../../components/toggleSwitch'
// import { convertBlobToBase64, getCroppedImg } from "../../../../utils/helpers";
const WidgetItem = ({ widgets, setWidgets }) => {
    const [crop, setCrop] = useState({ x: 0, y: 0 })
    const [zoom, setZoom] = useState(1)
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
    const [state, setState] = useState({
        selectedWidget: "",
        currentWidgetIndex: null,
        itemInputs: {},
        editingItem: {},
        currentFile: null,
        isModalOpen: false,
    });
    const togglePro = (key) => {
        setWidgets((prev) => ({
            ...prev,
            [key]: {
                ...prev[key],
                type: prev[key].type === "pro" ? "regular" : "pro",
            },
        }));
    };
    const updateState = (key, value, isNested = false) => {
        setState((prevState) => ({
            ...prevState,
            [key]: isNested ? { ...prevState[key], ...value } : value,
        }));
    };
    const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels);
    }, []);

    const handleImageUpload = async (event, index) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            updateState("currentFile", file)
            updateState("isModalOpen", true)
            updateState("currentWidgetIndex", index)
        }
    };
    const handleCrop = async () => {
        if (!croppedAreaPixels) {
            throw new Error("Crop area is not set properly.");
        }
        const imageSrc = URL.createObjectURL(state.currentFile)

        const croppedImageFile = await getCroppedImg(imageSrc, croppedAreaPixels);

        // Clean up memory
        URL.revokeObjectURL(imageSrc);

        if (!croppedImageFile) {
            throw new Error("Failed to process cropped image.");
        }

        const croppedImage = await convertBlobToBase64(croppedImageFile);; // Base64 String

        if (!croppedImage) {
            console.error("Failed to generate cropped image!");
            return;
        }

        if (state.currentWidgetIndex === null || state.currentWidgetIndex < 0) {
            console.error("Invalid widget index!");
            return;
        }

        // Ensure that prevWidgets is an array before updating
        setWidgets((prevWidgets) => {
            if (!Array.isArray(prevWidgets)) {
                console.error("Widgets state is not an array!");
                return prevWidgets; // Return previous state to prevent errors
            }

            // Create a new array (copy of prevWidgets)
            const updatedWidgets = [...prevWidgets];

            if (updatedWidgets[state.currentWidgetIndex]) {
                // Create a new object instead of modifying the old one
                updatedWidgets[state.currentWidgetIndex] = {
                    ...updatedWidgets[state.currentWidgetIndex],
                    image: croppedImage,
                };
            } else {
                console.error(`Widget at index ${state.currentWidgetIndex} not found!`);
            }

            return updatedWidgets;
        });

        // Reset states after cropping
        updateState("currentWidgetIndex", null);
        updateState("currentFile", null);
        updateState("isModalOpen", false);
    };
    const handleWidgetDetailsChange = (index, field, value) => {
        setWidgets((prevWidgets) =>
            prevWidgets.map((widget, idx) =>
                idx === index ? { ...widget, [field]: value } : widget
            )
        );
    };
    return (
        <div>
            {widgets && widgets?.map((widget, index) => (
                <div key={widget?.name} className="p-4  bg-[#F9F9F9] ">
                    <div className="bg-white p-4 relative">
                        <h3 className="text-2xl font-roboto-mono text-dark font-bold capitalize mb-2">{widget?.type?.replace(/([A-Z])/g, " $1")}</h3>


                        <div className="grid md:grid-cols-7 grid-cols-1 gap-4 mb-5">
                            {/* <input
                                type="text"
                                className="border border-bgprimary text-[#1F2937AB] font-medium  text-[16px] font-quicksand rounded-md p-2 w-full"
                                placeholder="Widget Name"
                                value={widget.name}
                                onChange={(e) => handleWidgetDetailsChange(index, "name", e.target.value)}
                            /> */}
                            <div className="col-span-2 self-center">
                                <label htmlFor="">Default URL</label>
                                <input
                                    type="url"
                                    className="border h-fit border-bgprimary text-[#1F2937AB] font-medium text-[16px] font-quicksand rounded-md p-2 w-full"
                                    placeholder="Enter a valid URL"
                                    value={widget?.url}
                                    onChange={(e) => handleWidgetDetailsChange(index, "url", e.target.value)}
                                    pattern="https?://.*"
                                    title="Please enter a valid URL (starting with http:// or https://)"
                                />
                            </div>
                            <div className="col-span-1 self-center">
                                <label htmlFor="">Default Type</label>
                                <ToggleSwitch
                                    checked={widget?.defaultType === "pro"}
                                    onChange={(checked) => handleWidgetDetailsChange(index, "defaultType", checked ? "pro" : "regular")}
                                />
                            </div>
                            <div className="col-span-2 self-center">
                                <label htmlFor=""> Default Image </label>
                                <input
                                    type="file"
                                    className="border h-fit border-bgprimary text-[#1F2937AB] font-medium  text-[16px] font-quicksand rounded-md p-2 w-full"
                                    onChange={(e) => handleImageUpload(e, index)}
                                    accept="image/*"
                                />
                            </div>
                            <div className="col-span-2">
                                {widget.image && (
                                    <img
                                        src={widget?.image.startsWith("data:image") ? widget.image : `${BASE_URL_IMAGE}${widget.image}`}
                                        alt="image"
                                        className="w-40 h-40 object-cover border rounded-md"
                                    />
                                )}
                            </div>

                        </div>

                    </div>

                </div>
            ))}


            {state.isModalOpen && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white p-4 rounded-lg shadow-lg w-[350px] h-[600px] relative">
                        <h2 className="text-lg font-bold mb-2">Crop Your Image</h2>
                        <div className="crop-container h-[200px] w-full">
                            <Cropper
                                image={URL.createObjectURL(state.currentFile)}
                                crop={crop}
                                zoom={zoom}
                                aspect={4 / 3}
                                onCropChange={setCrop}
                                onCropComplete={onCropComplete}
                                onZoomChange={setZoom}
                                style={{ height: "200px", width: "100%" }}
                            />
                        </div>
                        <div className="controls">
                            <input
                                type="range"
                                value={zoom}
                                min={1}
                                max={3}
                                step={0.1}
                                aria-labelledby="Zoom"
                                onChange={(e) => {
                                    setZoom(e.target.value)
                                }}
                                className="zoom-range"
                            />
                        </div>

                        <div className="flex justify-end space-x-2 mt-4 absolute bottom-4 left-[35%] translate-x-[-50%] w-full">
                            <button className="px-4 py-2 bg-gray-400 text-dark rounded border border-bgprimary" onClick={() => updateState("isModalOpen", false)}>
                                Cancel
                            </button>
                            <button className="px-4 py-2 bg-bgprimary text-dark font-roboto-mono font-bold rounded" onClick={handleCrop}>
                                Crop & Save
                            </button>
                        </div>


                    </div>
                </div>
            )}
        </div>
    )
}

export default WidgetItem
